import { Box, Heading, Link as ChakraLink, Stack, Text, Button } from '@chakra-ui/react';
import { HiDownload } from 'react-icons/hi';

export default function DataDownload() {
  return (
    <Box py='10'>
      <Box
        maxW='3xl'
        mx='auto'
        bg='white'
        border='1px solid'
        borderColor='gray.200'
        boxShadow='sm'
        borderRadius='md'
        p='8'
      >
        <Stack gap='6'>
          <Heading as='h1' size='xl'>
            Simplified Saskatchewan Detailed Soil Survey Shapefile
          </Heading>
          <Box h='1px' w='full' bg='gray.200' />
          <Text fontSize='md' color='gray.700' lineHeight='tall' overflowWrap='anywhere' wordBreak='break-word'>
            This zipfile contains a shapefile that includes the most commonly requested data displayed on SKSIS. <br />  <br />
             The soil polygon data shown on SKSIS is from the detailed soil survey for Saskatchewan, which can be accessed here:{' '}
            <ChakraLink href='https://sis.agr.gc.ca/cansis/nsdb/dss/v3/index.html' target='_blank' rel='noopener noreferrer'>Soil Survey (CanSIS)</ChakraLink> <br/><br/>
            {' '}
            However, that version of the dataset does not contain all fields included here as some fields were left out of the CanSIS version for consistency between provinces. The complete version of the detailed soil survey will soon be made available for download from SKSIS.
          </Text>
          <Box pt='2'>
            <Button asChild colorScheme='blue' size='md'>
              <ChakraLink
                href='https://object-arbutus.cloud.computecanada.ca/sksis-download/Simplified_SK_DSS_v1.zip'
                download
                display='inline-flex'
                alignItems='center'
                gap='2'
              >
                <HiDownload />
                Download shapefile (ZIP)
              </ChakraLink>
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}


